var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._b({attrs:{"dense":"","headers":_vm.headers,"items":_vm.data,"loading":_vm.loading},on:{"click:row":_vm.onRowClick},scopedSlots:_vm._u([{key:"item.warehouse_id",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.warehouse_id[1])+" ")]}},{key:"item.promotion_id",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.promotion_id.description)+" ")]}},{key:"item.sale_count",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.sale_count.value)+" ")]}}],null,true)},'v-data-table',_vm.tableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }